// extracted by mini-css-extract-plugin
export default {"footerbg":"Footer_footerbg__9RNRu","footercontent":"Footer_footercontent__l5IYg"};